// 1. 외부 패키지
import { useSetRecoilState } from "recoil";


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import AreaTypeToggle from "./area-type-toggle";
import basic_detail_atom from "../../atom/basic-detail";


// 4. 타입
declare const window:any

const PcTop = () => {

	const setBasicDetail = useSetRecoilState(basic_detail_atom);

	const url = window.location.href;

	const onClickDeclare = () => {
		setBasicDetail((_) => ({
			..._,
			popup: 1
		}))
	};

	const onClickShare = () => {
		if(typeof window.AndroidScript != 'undefined' && window.AndroidScript?.sharingText) {
			window.AndroidScript.sharingText(url);
			return;
		}

		try {
			window.webkit.messageHandlers.sharing.postMessage(url);
			return;
		} catch {

		}

		setBasicDetail((_) => ({
			..._,
			popup: 3
		}));
	};


	return (
		<div>
			<div className='top_btn'>
				<AreaTypeToggle />
				<button type='button' className='declare' onClick={onClickDeclare} />
				<button type='button' className='share' onClick={onClickShare}/>
			</div>
			<p className='toggle_desc pd_top'>* 평전환시 소수점 첫째자리에서 반올림한 값입니다.</p>
		</div>
	);
};

export default PcTop;